<div class="container">

    <!-- Loading -->
    <div class="card" *ngIf="loading">
        <p>Loading subscriber list...</p>
    </div>

    <!-- Error -->
    <div class="card error" *ngIf="error">
        {{ error }}
    </div>

    <!-- DESKTOP TABLE -->
    <div class="card d-none d-md-block" *ngIf="!loading && !error && subscribers.length">

        <h1 class="title">प्रतिनिधीचे नाव: {{ rep_name }}</h1>
        <h2 class="title">वर्गणीदार नूतनीकरण यादी ({{ monthYear }})</h2>

        <div class="table-responsive">
            <table class="table table-sm subscriber-table">
                <thead>
                    <tr>
                        <th>अ.क्रमांक</th>
                        <th>वर्गणीदार क्रमांक</th>
                        <th>वर्गणीदारचे नाव</th>
                        <th>पत्ता</th>
                        <th>पिन कोड</th>
                        <th>तालुका</th>
                        <th>जिल्हा</th>
                        <th>राज्य</th>
                        <th>देश</th>
                        <th>मोबाईल नंबर</th>
                        <th>वैध दिनांक</th>
                        <th>वितरण पद्धत</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let sub of subscribers; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ sub.sub_no }}</td>
                        <td>{{ sub.name }}</td>
                        <td>{{ sub.address }}</td>
                        <td>{{ sub.pincode }}</td>
                        <td>{{ sub.taluka }}</td>
                        <td>{{ sub.district }}</td>
                        <td>{{ sub.state }}</td>
                        <td>{{ sub.country }}</td>
                        <td>{{ sub.mobileNumber }}</td>
                        <td>
                            {{ sub.start_period | date:'dd/MM/yyyy' }} -
                            {{ sub.end_period | date:'dd/MM/yyyy' }}
                        </td>
                        <td>{{ sub.delivery_mode }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="text-center mb-3">
            <p><b>-: Payment Link :-</b></p>
            <p> https://www.evivek.com/subscriber-growth-campaign-2026/</p>
        </div>
    </div>

    <!-- MOBILE CARDS -->
    <!-- <div class="d-block d-md-none" *ngIf="!loading && !error && subscribers.length">

        <div class="text-center mb-3">
            <h1 class="title">प्रतिनिधीचे नाव: {{ rep_name }}</h1>

            <h3 class="count-title">वर्गणीदार नूतनीकरण यादी ({{ monthYear }})</h3>

            <h3 class="count-title">
                एकूण वर्गणीदारांची संख्या: {{ subscribers.length }}
            </h3>
        </div>

        <div class="card mb-2" *ngFor="let sub of subscribers; let i = index">

            <p><b>अ.क्रमांक:</b> {{ i + 1 }}</p>
            <p><b>वर्गणीदार क्रमांक:</b> {{ sub.sub_no }}</p>
            <p>
                <span><b>वर्गणीदारचे नाव:</b></span>
                <span class="extra-bold">{{ sub.name }}</span>
            </p>
            <p><b>पत्ता:</b> {{ sub.address }}<br>
                {{ sub.taluka }}, {{ sub.district }}, {{ sub.state }} – {{ sub.pincode }}, <br>
                {{ sub.country }}
            </p>
            <p><b>मोबाईल नंबर:</b> {{ sub.mobileNumber }}</p>
            <p><b>वैध दिनांक:</b>
                {{ sub.start_period | date:'dd/MM/yyyy' }} -
                {{ sub.end_period | date:'dd/MM/yyyy' }}
            </p>
            <p><b>वितरण पद्धत:</b> {{ sub.delivery_mode }}</p>
        </div>

        <div class="text-center mb-3">
            <p><b>-: Payment Link :-</b></p>
            <p> https://www.evivek.com/subscriber-growth-campaign-2026/</p>
        </div>

    </div> -->

    <!-- MOBILE TABLE VIEW -->
    <div class="d-block d-md-none" *ngIf="!loading && !error && subscribers.length">

        <!-- PAGE HEADINGS -->
        <div class="text-center mb-3">
            <h1 class="title">प्रतिनिधीचे नाव: {{ rep_name }}</h1>

            <h3 class="count-title">
                वर्गणीदार नूतनीकरण यादी ({{ monthYear }})
            </h3>

            <h3 class="count-title">
                एकूण वर्गणीदारांची संख्या: {{ subscribers.length }}
            </h3>
        </div>

        <div class="table-responsive">
            <table class="table table-bordered table-sm mobile-table">
                <thead class="table-light">
                    <tr>
                        <th>अ.क्र.</th>
                        <th>वर्गणीदार क्र.</th>
                        <th>नाव</th>
                        <th>मोबाईल</th>
                        <th>वैध दिनांक</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let sub of subscribers; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ sub.sub_no }}</td>
                        <td class="name-col">{{ sub.name }}</td>
                        <td>{{ sub.mobileNumber }}</td>
                        <td>
                            {{ sub.start_period | date:'dd/MM/yyyy' }} -
                            {{ sub.end_period | date:'dd/MM/yyyy' }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="text-center mb-3">
            <p><b>-: Payment Link :-</b></p>
            <p>https://www.evivek.com/subscriber-growth-campaign-2026/</p>
        </div>

    </div>

    <!-- NO DATA (Desktop + Mobile both) -->
    <div class="card" *ngIf="!loading && !error && !subscribers.length">
        <p>No subscribers found.</p>
    </div>

</div>